module.exports = __webpack_public_path__ + "static/media/5.75af38a2.png";